module.exports = __webpack_public_path__ + "../resources/img/@temp_chart.650e972a.png";